var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "16px",
    viewBox: "0 0 9 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftChevron") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftChevron",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron",
    transform: "translate(4.500000, 8.000000) rotate(-90.000000) translate(-4.500000, -8.000000) translate(-4.000000, 4.000000)",
    fill: "#006699",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6-Copy-3",
    transform: "translate(8.500000, 4.000000) rotate(-90.000000) translate(-8.500000, -4.000000) ",
    points: "4.76 -4 8.5981648 3.88234947 4.76 12 5.8519984 12 12.24 3.93129263 5.8519984 -4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default __webpack_public_path__ + "static/media/leftChevron.01466cd2ca09c41ee8eaa2654695a4a5.svg";
export { ForwardRef as ReactComponent };